import { Gift, MessageCircle } from "lucide-react";
import { Reveal, SectionBadge } from "./Shared";
import { waLink } from "../data";

export default function GiftCard() {
  return (
    <section id="gift-cards" data-testid="gift-card-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <div className="grid grid-cols-1 items-center gap-12 rounded-[32px] border border-leaf/15 bg-bone p-8 md:p-16 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <SectionBadge>04 — Give the Gift of Wellness</SectionBadge>
              <h2 className="mt-8 font-serif text-4xl font-medium leading-[0.95] tracking-tighter text-ink md:text-6xl">
                A little <span className="italic text-melon">squeeze</span> goes a long way.
              </h2>
              <p className="mt-6 max-w-lg text-base font-light leading-relaxed text-leaf/85 md:text-lg">
                Treat someone to something fresh. Main Squeeze gift cards are
                perfect for birthdays, celebrations, thank-yous, corporate
                gifts—or just because.
              </p>
              <a
                href={waLink("Hi Main Squeeze! I'm interested in purchasing a gift card.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="gift-card-button"
                className="mt-8 inline-flex items-center gap-3 rounded-full bg-leaf px-8 py-4 text-sm font-medium tracking-wide text-cream transition-[background-color,transform] duration-300 hover:scale-95 hover:bg-melon"
              >
                <MessageCircle className="h-4 w-4" />
                Purchase a Gift Card
              </a>
            </div>
            <div className="flex flex-col items-start gap-6 lg:col-span-5 lg:items-end">
              <div className="flex h-28 w-28 items-center justify-center rounded-full border border-leaf/15 bg-cream md:h-36 md:w-36">
                <Gift className="h-12 w-12 text-melon md:h-16 md:w-16" strokeWidth={1.25} />
              </div>
              <p className="max-w-xs text-sm font-light leading-relaxed text-leaf/70 lg:text-right">
                Available in multiple denominations • Redeemable toward juices,
                wellness shots &amp; cleanses
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
